
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"29","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.011 9.746c-.693 0-1.235.372-1.235 1.032 0 2.012.237 4.904.237 6.917 0 .524.457.744.998.744.406 0 .981-.22.981-.744 0-2.012.237-4.905.237-6.917 0-.66-.558-1.032-1.218-1.032zM14.024 19.604c-.744 0-1.302.591-1.302 1.302 0 .693.558 1.302 1.302 1.302.693 0 1.285-.609 1.285-1.302 0-.71-.592-1.302-1.285-1.302z","fill":"#F77"}}),_c('path',{attrs:{"d":"M27.64 22.51L16.153 3.465A2.529 2.529 0 0014 2.247c-.876 0-1.702.466-2.154 1.217L.36 22.51a2.52 2.52 0 00-.036 2.536 2.52 2.52 0 002.19 1.278h22.97a2.52 2.52 0 002.19-1.278 2.52 2.52 0 00-.036-2.536zm-1.552 1.64a.694.694 0 01-.603.352H2.515a.694.694 0 01-.593-1.05L13.407 4.405A.696.696 0 0114 4.07c.241 0 .468.128.593.335l11.485 19.047a.693.693 0 01.01.698z","fill":"#F77"}})])
          )
        }
      }
    